import { List, Map as ImmutableMap, fromJS } from 'immutable';
import { fromMetricKey } from 'reporting-data/v2/dataset/datasetMetrics';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { generateDrilldownName, generateDrilledDefinition
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'repo... Remove this comment to see the full error message
} from 'reporting-snowflake/relational/enhance/drilldown/generate';
import { createRelationalReportFromBaseReport } from 'reporting-snowflake/relational/utils/report-utils';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import { GAUGE } from 'reporting-data/constants/chartTypes';
import { VisualizationTypes } from 'reporting-data/tsTypes/visualization';
// @ts-expect-error Untyped import
import { translateClickEvent } from '../../../reports/inferLogic/components/ReportWithVisualization';
function configReportDrilldown({
  report,
  drilldownEvent,
  onDrilldown
}) {
  const {
    layer,
    point
  } = drilldownEvent;
  if (getReportChartType(report) === GAUGE) {
    translateClickEvent(report, VisualizationTypes.GAUGE, {
      row: fromJS(drilldownEvent.row),
      layer: fromJS(drilldownEvent.layer),
      dataset: fromJS(drilldownEvent.dataset)
    });
  } else {
    // Note: prototype to handle click event for pie chart.
    // Eventually, we'd extract this out to implement a standardized drilldownList
    const dim = layer.getIn(['color', 'field']);
    const metric = layer.getIn(['angle', 'field']);
    const {
      property,
      type
    } = fromMetricKey(metric);
    const row = point.get('sliceRow');
    const drilldownName = 'PIE Drilldown';
    const drilldownList = List([...(dim ? [row.get(dim)] : []), property, type]);
    onDrilldown(drilldownList, {
      name: drilldownName,
      datasetKey: 'primary'
    });
  }
}
function SFReportDrilldown({
  report,
  drilldownEvent: clickEvent,
  dataset,
  onDrilldown,
  deps
}) {
  const dataRow = clickEvent.row;
  const reportDefinition = createRelationalReportFromBaseReport(report);
  const drilldownName = generateDrilldownName(clickEvent, dataset, reportDefinition);

  // Existing infrastructure for handling drilldowns for SF reports
  const drilledDefinition = generateDrilledDefinition(dataRow, deps, reportDefinition, 'JANUARY');
  onDrilldown(ImmutableMap({
    reportDefinition: drilledDefinition,
    name: drilldownName
  }));
}
export function handleDrilldown({
  report,
  drilldownEvent,
  onDrilldown,
  deps,
  dataset
}) {
  if (!onDrilldown) {
    return;
  }
  if (isConfigReport(report)) {
    configReportDrilldown({
      report,
      drilldownEvent,
      onDrilldown
    });
  } else {
    SFReportDrilldown({
      report,
      drilldownEvent,
      onDrilldown,
      deps,
      dataset
    });
  }
}